export const locationConstants = {
  GET_JURISFROMIP_REQUEST: "GET_JURISFROMIP_REQUEST",
  GET_JURISFROMIP_SUCCESS: "GET_JURISFROMIP_SUCCESS",
  GET_JURISFROMIP_FAILURE: "GET_JURISFROMIP_FAILURE",
};